import { createContext, useContext } from "react"

import { GetRovingTabIndexItemProps } from "shared/types/RovingTabIndex"

export interface ChipListContextValue<
  ElementType extends HTMLElement = HTMLElement
> {
  getElementProps: GetRovingTabIndexItemProps<ElementType>
}

export const ChipListContext = createContext<ChipListContextValue | null>(null)

export const ChipIndexContext = createContext<number | undefined>(undefined)

export const useChipIndex = () => useContext(ChipIndexContext)
